<template>
    <div class="user_popup">
        <div class="user_popup1">
            <img src="../assets/image/head.png" alt="">
            <p class="flex-coloum" v-if="userInfo && Object.keys(userInfo).length > 0">
                <span>{{ userInfo.nickname }} </span>
                <span class="t-font-16">{{ getUserTypeImg(userInfo).name }}</span>
            </p>

        </div>
        <div class="user_popup2 cursor_1" @click="openVip">
            <div class="user_popup2_1 cursor_1" v-if="userInfo.vipType == 'common'">
                <!-- <img :src="userImg[0]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1" v-else-if="userInfo.vipType == 'cmember'">
                <!-- <img :src="userImg[4]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_3 cursor_1">{{ userInfo.vipDate }} &nbsp;{{ userInfo.freeWordCount }}字符
                </div>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1" v-else-if="userInfo.vipType == 'month'">
                <!-- <img :src="userImg[3]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_3 cursor_1">{{ userInfo.vipDate }}</div>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1" v-else-if="userInfo.vipType == 'three_months'">
                <!-- <img :src="userImg[3]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_3 cursor_1">{{ userInfo.vipDate }}</div>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1" v-else-if="userInfo.vipType == 'half_year'">
                <!-- <img :src="userImg[3]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_3 cursor_1">{{ userInfo.vipDate }}</div>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1" v-else-if="['vipyear', 'year'].includes(userInfo.vipType)">
                <!-- <img :src="userImg[2]" alt=""> -->
                <p class="userVipTitle">{{ getUserTypeImg(userInfo).name }}</p>
                <div class="user_popup2_3 cursor_1">{{ userInfo.vipDate }}</div>
                <div class="user_popup2_2 cursor_1">点击前往></div>
            </div>
            <div class="user_popup2_1 cursor_1"
                v-else-if="['perpetual', 'year_ensure', 'year_coach'].includes(userInfo.vipType)">
                <img :src="userImg[1]" alt="">
            </div>
            <div class="user_popup2_1 cursor_1" v-else>
                <img :src="userImg[1]" alt="">
            </div>
        </div>

        <div class="user_popup3">
            <div class="user_popup3_1 cursor_1" v-for="(item, i) in toolList" :key="i" @click="select(i, item)">
                <img :src="item.icon" alt="">
                {{ item.name }}
            </div>
        </div>
    </div>

</template>

<script>
import data from '@/assets/data';
import { EventBus } from '@/utils/eventBus';
import InApi from '@/api/invite'
export default {
    props: {
        userInfo: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
            userImg: data.userImg,
            userData: data.userData,
            isVisible: false,//显示隐藏
        }
    },
    computed: {
        toolList() {
            let list = data.userData
            if (this.userInfo && this.userInfo.inviteCode != null) {
                list = data.userData.filter(item => item.asname !== 'yqm')
            }
            return list
        }
    },
    mounted() {
        EventBus.$on('openUserinfo', () => {
            this.isVisible = true
        })
    },
    beforeDestroy() {
        EventBus.$off('openUserinfo');
    },
    methods: {
        openVip() {
            this.close()
            EventBus.$emit('openVip')
        },
        close() {
            EventBus.$emit('close')
        },
        select(i, item) {
            this.close()
            if (['gmjl', 'fmjl'].includes(item.asname)) {
                sessionStorage.setItem('recordI', i);
                this.$router.push({ path: '/record' });
                EventBus.$emit('recordI', i)
            } else if (item.asname === 'yhxy') {
                window.open('https://api.esrke.com/rest/novel/public/protocol?type=yhxy&platform=pc')
            } else if (item.asname === 'yszc') {
                window.open('https://api.esrke.com/rest/novel/public/protocol?type=yszc&platform=pc')
            } else if (item.asname === 'hsz') {
                localStorage.removeItem(this.rSearchKey)
                this.$router.push({ path: '/userRecycle' })
            } else if (item.asname === 'yqm') {
                this.$prompt('请输入邀请码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    //接口绑定
                    InApi.inviteCodeBind({ code: value }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('绑定邀请码操作成功')
                            window.location.href = '/'
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
            else if (item.asname === 'tcsc') {
               this.$router.push({ path: '/userCollect' });
            }
            else if (item.asname === 'tcdl') {
                EventBus.$emit('openPrompt', 2)
            }
        }
    }
}
</script>

<style>
.user_popup {
    background: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(7, 7, 7, 0.28);
    border-radius: 8px;
    padding: 20px;
}

.user_popup1 {
    display: flex;
    height: 58px;
    align-items: center;
    font-weight: bold;
    font-size: 19px;
    color: #333333;
}

.user_popup1 img {
    width: 58px;
    height: 58px;
    margin-right: 10px;
}

.user_popup2 {
    width: 292px;
    height: 97px;
    background: url('@/assets/image/icon_userInfo.png') no-repeat;
    background-size: 100% 100%;
    margin: 10px 0;
    padding: 0 30px;
    display: flex;
    align-items: center;
}
.userVipTitle{
    font-family:'Courier New', Courier, monospace;
    color: #FFFFFF;
    font-size: 18px;
    padding: 0;
    margin: 0;
}
.user_popup2_2 {
    font-size: 14px;
    color: #FFA700;
    margin-top: 5px;
}

.user_popup2_3 {
    font-size: 12px;
    color: #FFFFFF;
    margin-top: 3px;
}

.user_popup3 {
    width: 292px;
    display: flex;
    flex-wrap: wrap;
}

.user_popup3_1 {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #333333;
    width: calc((100% - 40px) / 3);
    margin-bottom: 10px;
    margin-right: 20px;
    cursor: pointer;
}

.user_popup3_1:nth-child(3n) {
    margin-right: 0;
}

.user_popup3_1 img {
    width: 21px;
    margin-bottom: 5px;
}

/* 动画效果 */
.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.3s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
</style>